"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectQuoteEntry = exports.selectIsSubmitDisabled = exports.selectQuoteSubmitStatus = void 0;
const reselect_1 = require("reselect");
exports.selectQuoteSubmitStatus = (0, reselect_1.createSelector)((state) => state.quote, (quote) => quote.submitStatus);
exports.selectIsSubmitDisabled = (0, reselect_1.createSelector)((state) => state.quote, (quote) => quote.disabled);
const selectQuoteEntry = (key) => (0, reselect_1.createSelector)((state) => state.quote, (quote) => quote.form[key]);
exports.selectQuoteEntry = selectQuoteEntry;
